(function () {
  "use strict";

  /* =====================================================
     BACKEND API & SESSION
  ===================================================== */

  const DATA =
    window.DASH_TWINE_CHATBOT ||
    window.DASH_TWINE_CHATBOT_CONFIG ||
    {};

  const CHATBOT_API_URL =
    DATA.apiUrl || "http://localhost:5000/api/chat";

  let sessionId = localStorage.getItem("dashTwineChatSessionId");

  if (!sessionId) {
    sessionId =
      typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : Date.now().toString(36) + Math.random().toString(36).slice(2);

    localStorage.setItem("dashTwineChatSessionId", sessionId);
  }

  /* =====================================================
     INITIALIZATION
  ===================================================== */

  function initAIChatbot() {
    const chatbot = document.getElementById("ai-chatbot");

    if (!chatbot || chatbot.dataset.initialized === "true") {
      return;
    }

    const toggleButton = chatbot.querySelector(".ai-chatbot__toggle");
const closeButton = chatbot.querySelector(".ai-chatbot__close");
const messages = chatbot.querySelector(".ai-chatbot__messages");

let contactFooter = chatbot.querySelector(".ai-chatbot__contact-footer");

if (!contactFooter) {
  contactFooter = document.createElement("div");
  contactFooter.className = "ai-chatbot__contact-footer";
  contactFooter.setAttribute("aria-label", "Contact Dash & Twine");

  messages.insertAdjacentElement("afterend", contactFooter);
}

// Optional elements: chatbot FAQ-only mode mein bhi chalega.
const input = chatbot.querySelector(".ai-chatbot__input");
const form = chatbot.querySelector(".ai-chatbot__form");

if (!toggleButton || !closeButton || !messages) {
  console.error("Chatbot required elements missing:", {
    toggleButton: !!toggleButton,
    closeButton: !!closeButton,
    messages: !!messages
  });
  return;
}
    if (!toggleButton || !closeButton || !messages) {
      return;
    }

    chatbot.dataset.initialized = "true";

    /* =====================================================
       OPEN / CLOSE
    ===================================================== */

  function openChat() {
    chatbot.classList.add("is-open");
    toggleButton.setAttribute("aria-expanded", "true");
  }

    function closeChat() {
      chatbot.classList.remove("is-open");
      toggleButton.setAttribute("aria-expanded", "false");
    }

    toggleButton.addEventListener("click", function () {
  if (chatbot.classList.contains("is-open")) {
    closeChat();
  } else {
    openChat();
  }
});

    closeButton.addEventListener("click", closeChat);

    // Escape key se chatbot close hoga.
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape" && chatbot.classList.contains("is-open")) {
    closeChat();
  }
});
// Chatbot box ke bahar click karne par close hoga.

document.addEventListener(
  "click",
  function (event) {
    if (!chatbot.classList.contains("is-open")) return;

    const target = event.target;

    // FAQ category, question aur back buttons par chatbot open rahega.
    if (
      target instanceof Element &&
      target.closest(
        ".ai-chatbot__faq-menu, " +
        ".ai-chatbot__faq-questions, " +
        ".ai-chatbot__faq-category, " +
        ".ai-chatbot__faq-question, " +
        ".ai-chatbot__faq-back"
      )
    ) {
      return;
    }

    // Chatbot ke bahar click hone par hi close karo.
    if (!chatbot.contains(target)) {
      closeChat();
    }
  },
  true
);

    /* =====================================================
       MESSAGE RENDERING
    ===================================================== */

    function addMessage(text, type) {
      const message = document.createElement("div");

      message.className =
        "ai-chatbot__message ai-chatbot__message--" + type;

      String(text).split("\n").forEach(function (line, index) {
        message.appendChild(document.createTextNode(line));

        if (index < String(text).split("\n").length - 1) {
          message.appendChild(document.createElement("br"));
        }
      });

      messages.appendChild(message);
      messages.scrollTop = messages.scrollHeight;

      return message;
    }

    function addLink(link) {
      if (!link || !link.url || !link.text) return;

      try {
        const url = new URL(link.url);

        if (url.protocol !== "https:") return;

        const wrapper = document.createElement("div");
        wrapper.className = "ai-chatbot__message-link";

        const anchor = document.createElement("a");
        anchor.href = url.href;
        anchor.textContent = link.text;
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";

        wrapper.appendChild(anchor);
        messages.appendChild(wrapper);
        messages.scrollTop = messages.scrollHeight;
      } catch (error) {
        console.warn("Invalid chatbot link:", error);
      }
    }

    function showTyping() {
      const typing = document.createElement("div");

      typing.className =
        "ai-chatbot__message ai-chatbot__message--bot";

      const typingIndicator = document.createElement("span");
      typingIndicator.className = "ai-chatbot__typing";

      for (let i = 0; i < 3; i++) {
        typingIndicator.appendChild(document.createElement("span"));
      }

      typing.appendChild(typingIndicator);
      messages.appendChild(typing);
      messages.scrollTop = messages.scrollHeight;

      return typing;
    }

    /* =====================================================
       CONTACT ACTIONS
    ===================================================== */


function addContactActions(userQuestion) {
  const contact = DATA.contact;

  if (!contact) {
    console.warn("Chatbot contact configuration is missing.");
    return;
  }

  contactFooter.replaceChildren();

  const actions = document.createElement("div");
  actions.className = "ai-chatbot__contact-actions";

  const whatsapp = String(contact.whatsapp || "").replace(/\D/g, "");
  const phone = String(contact.phone || "").trim();
  const email = String(contact.email || "").trim();

  function addContactLink(label, href, className, iconSvg, title) {
    if (!href) return;

    const anchor = document.createElement("a");
    anchor.className = "ai-chatbot__contact-button " + className;
    anchor.href = href;
    anchor.setAttribute("aria-label", title);
    anchor.title = title;

    if (href.startsWith("https://")) {
      anchor.target = "_blank";
      anchor.rel = "noopener noreferrer";
    }

    const iconElement = document.createElement("span");
    iconElement.className = "ai-chatbot__contact-icon";
    iconElement.setAttribute("aria-hidden", "true");
    iconElement.innerHTML = iconSvg;

    const textElement = document.createElement("span");
    textElement.className = "ai-chatbot__contact-label";
    textElement.textContent = label;

    anchor.append(iconElement, textElement);
    actions.appendChild(anchor);
  }

  const whatsappIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"
      width="24" height="24" fill="currentColor">
      <path d="M16 2.5A13.5 13.5 0 0 0 4.4 22.9L2.5 29.5l6.8-1.8A13.5 13.5 0 1 0 16 2.5Zm0 24.3a11 11 0 0 1-5.6-1.5l-.4-.2-4.1 1.1 1.1-4-.3-.5A11 11 0 1 1 16 26.8Zm6-8.1c-.3-.2-1.8-1-2.1-1.1-.3-.1-.5-.2-.7.2l-1 1.2c-.2.2-.4.3-.7.1a9 9 0 0 1-2.7-1.7 10 10 0 0 1-1.8-2.3c-.2-.3 0-.5.2-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.4c-.3-.7-.6-.6-.8-.6h-.6c-.2 0-.6.1-.9.4-.3.4-1.1 1.2-1.1 2.8s1.2 3.2 1.4 3.4c.1.2 2.3 3.6 5.6 5 .8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.6-.5Z"/>
    </svg>`;

  const callIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
      width="24" height="24" fill="currentColor">
      <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z"/>
    </svg>`;

  const emailIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
      width="24" height="24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2"/>
      <path d="m3 7 9 6 9-6"/>
    </svg>`;

  if (whatsapp) {
    const message =
      "Hi Dash & Twine Support, I need help with: " + userQuestion;

    addContactLink(
      "WhatsApp",
      "https://wa.me/" + whatsapp + "?text=" + encodeURIComponent(message),
      "ai-chatbot__contact-button--whatsapp",
      whatsappIcon,
      "Contact us on WhatsApp"
    );
  }

  if (phone) {
    addContactLink(
      "Call",
      "tel:" + phone.replace(/[^\d+]/g, ""),
      "ai-chatbot__contact-button--call",
      callIcon,
      "Call Dash & Twine"
    );
  }

  if (email) {
    const subject = "Dash & Twine Product Enquiry";
    const body =
      "Hi Dash & Twine Support,\n\nI need help with: " + userQuestion;

    addContactLink(
      "Email",
      "mailto:" + email +
        "?subject=" + encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(body),
      "ai-chatbot__contact-button--email",
      emailIcon,
      "Email Dash & Twine"
    );
  }

  if (actions.children.length > 0) {
    contactFooter.appendChild(actions);
  }
}


    /* =====================================================
       PRODUCT QUERY DETECTION
    ===================================================== */

    function getProductSearchTerm(message) {
      const text = message.toLowerCase();

      const categories = [
        {
          terms: [
            "perfume",
            "perfumes",
            "fragrance",
            "fragrances",
            "attar",
            "scent",
            "scents"
          ],
          query: "perfume"
        },
        {
          terms: [
            "cushion",
            "cushions",
            "pillow",
            "pillows"
          ],
          query: "cushion"
        },
        {
          terms: [
            "glassware",
            "glass wares",
            "glass",
            "glasses"
          ],
          query: "glassware"
        },
        {
          terms: [
            "gift",
            "gifts",
            "gift ideas"
          ],
          query: "gift"
        },
        {
          terms: [
            "children's apparel",
            "kids apparel",
            "children clothing",
            "kids clothing"
          ],
          query: "children"
        }
      ];

      for (const category of categories) {
        if (category.terms.some(function (term) {
          return text.includes(term);
        })) {
          return category.query;
        }
      }

      // Generic product browsing requests
      if (
        /\b(show|find|search|suggest|recommend|browse|explore)\b/i.test(text) &&
        /\b(products|product|items|catalog|collection)\b/i.test(text)
      ) {
        return "";
      }

      return null;
    }

    /* =====================================================
       PRODUCT SEARCH API
    ===================================================== */

    

async function searchProducts(query) {
  try {
    const baseUrl = CHATBOT_API_URL.replace(/\/$/, "");
    const params = new URLSearchParams();

    if (query && query.trim()) {
      params.set("q", query.trim());
    } else {
      params.set("browse", "true");
    }

    const response = await fetch(
      `${baseUrl}/products?${params.toString()}`
    );

    const data = await response.json();

    if (!response.ok || data.success === false) {
      throw new Error(
        data.message || `Product search failed: ${response.status}`
      );
    }

    return {
      success: true,
      products: Array.isArray(data.products) ? data.products : []
    };
  } catch (error) {
    console.error("Product Search Error:", error);

    return {
      success: false,
      products: [],
      error: true
    };
  }
}


    /* =====================================================
       PRODUCT CARDS
    ===================================================== */

    function addProductCards(products) {
      if (!Array.isArray(products) || products.length === 0) {
        return;
      }

      const container = document.createElement("div");
      container.className = "ai-chatbot__products";

      products.forEach(function (product) {
        const card = document.createElement("article");
        card.className = "ai-chatbot__product-card";

        if (product.imageUrl) {
          try {
            const imageURL = new URL(product.imageUrl);

            if (imageURL.protocol === "https:") {
              const image = document.createElement("img");

              image.className = "ai-chatbot__product-image";
              image.src = imageURL.href;
              image.alt = product.title || "Product";
              image.loading = "lazy";

              card.appendChild(image);
            }
          } catch (error) {
            console.warn("Invalid product image URL:", product.imageUrl);
          }
        }

        const details = document.createElement("div");
        details.className = "ai-chatbot__product-details";

        const title = document.createElement("h4");
        title.className = "ai-chatbot__product-title";
        title.textContent = product.title || "Product";

        details.appendChild(title);

        if (
          product.price !== undefined &&
          product.price !== null &&
          product.price !== ""
        ) {
          const amount = Number(product.price);

          if (Number.isFinite(amount)) {
            const price = document.createElement("p");
            price.className = "ai-chatbot__product-price";

            price.textContent =
              (product.currency || "AED") + " " + amount.toFixed(2);

            details.appendChild(price);
          }
        }

        if (product.productUrl) {
          try {
            const productURL = new URL(product.productUrl);

            if (productURL.protocol === "https:") {
              const link = document.createElement("a");

              link.className = "ai-chatbot__product-link";
              link.href = productURL.href;
              link.textContent = "View Product";
              link.target = "_blank";
              link.rel = "noopener noreferrer";

              details.appendChild(link);
            }
          } catch (error) {
            console.warn("Invalid product URL:", product.productUrl);
          }
        }

        card.appendChild(details);
        container.appendChild(card);
      });

      messages.appendChild(container);
      messages.scrollTop = messages.scrollHeight;
    }
    

/* =========================================================
   FAQ MATCHING + CLICKABLE FAQ MENU
========================================================= */

const FAQ_CATEGORIES = [
  "About Our Perfumes",
  "Fragrance Basics",
  "Longevity & Performance",
  "How to Use & Care",
  "Recommendations",
  "Specific Perfumes",
  "Orders & Payment",
  "Delivery",
  "Returns & Refunds",
  "Contact Us"
];

function normalizeFAQText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[’']/g, "")
    .replace(/[^a-z0-9\s-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function getFAQCategory(faq) {
  const question = normalizeFAQText(faq.question);
  const keywords = normalizeFAQText(
    (Array.isArray(faq.keywords) ? faq.keywords : []).join(" ")
  );
  const text = question + " " + keywords;

  // Returns and refunds must be checked before delivery.
  if (
    /\b(return|returns|refund|refunded|money back)\b/.test(text)
  ) {
    return "Returns & Refunds";
  }

  if (
    /\b(delivery|shipping|track order|tracking|delivery address|damaged|arrive|dispatch)\b/.test(text)
  ) {
    return "Delivery";
  }

  if (
    /\b(payment|pay|visa|mastercard|amex|installment|tabby|tamara|cancel order|cancel my order|confirmation email|order status|place an order)\b/.test(text)
  ) {
    return "Orders & Payment";
  }

  if (
    /\b(contact|speak with someone|talk to someone|support|customer service|phone number|email address|human agent)\b/.test(text)
  ) {
    return "Contact Us";
  }

  if (
    /\b(apply|application|sprays|layer|shake|store|storage|clothes|make perfume last longer|expire|expiry|expiration)\b/.test(text)
  ) {
    return "How to Use & Care";
  }

  if (
    /\b(edp|edt|eau de parfum|eau de toilette|oud meaning|what is oud|unisex|gender specific|gender neutral)\b/.test(text)
  ) {
    return "Fragrance Basics";
  }

  if (
    /\b(long lasting|longevity|projection|how long perfume last|last longer|lasting power|hot weather|uae weather|performance)\b/.test(text)
  ) {
    return "Longevity & Performance";
  }

  if (
    /\b(khamrah|qahwa|asad|bourbon|yara|lattafa|specific perfume)\b/.test(text)
  ) {
    return "Specific Perfumes";
  }

  if (
    /\b(recommend|recommendation|sweet|fresh|vanilla|woody|floral|masculine|everyday|daily use|summer|winter|office|party|date night|husband|wife|gift|unique|expensive|sophisticated|popular|sporty|occasion|for men|for women|women perfume|men perfume|best perfume)\b/.test(text)
  ) {
    return "Recommendations";
  }

  // Brand, authenticity, bottle sizes, samples and general store FAQs.
  return "About Our Perfumes";
}

function findMatchingFAQ(message) {
  const faqs = window.DASH_TWINE_FAQS || [];
  const text = normalizeFAQText(message);

  if (!text) return null;

  let bestMatch = null;
  let bestScore = 0;

  faqs.forEach(function (faq) {
    const phrases = [
      faq.question,
      ...(Array.isArray(faq.keywords) ? faq.keywords : [])
    ];

    phrases.forEach(function (phrase) {
      const normalizedPhrase = normalizeFAQText(phrase);

      if (!normalizedPhrase) return;

      let score = 0;

      if (text === normalizedPhrase) {
        score = 100;
      } else if (
        normalizedPhrase.length >= 8 &&
        text.includes(normalizedPhrase)
      ) {
        score = 40 + normalizedPhrase.length / 100;
      } else if (
        text.length >= 8 &&
        normalizedPhrase.includes(text)
      ) {
        score = 15;
      } else {
        const messageWords = new Set(text.split(" "));
        const phraseWords = normalizedPhrase
          .split(" ")
          .filter(function (word) {
            return word.length > 2;
          });

        const matchingWords = phraseWords.filter(function (word) {
          return messageWords.has(word);
        }).length;

        if (phraseWords.length > 0) {
          const ratio = matchingWords / phraseWords.length;

          if (matchingWords >= 2 && ratio >= 0.6) {
            score = 10 + ratio;
          }
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = faq;
      }
    });
  });

  return bestScore >= 10 ? bestMatch : null;
}

function clearFAQMenus() {
  messages
    .querySelectorAll(
      ".ai-chatbot__faq-menu, .ai-chatbot__faq-questions"
    )
    .forEach(function (element) {
      element.remove();
    });
}


function showFAQCategories() {
  clearFAQMenus();

  const wrapper = document.createElement("div");
  wrapper.className = "ai-chatbot__faq-menu";
  wrapper.style.display = "flex";
  wrapper.style.flexDirection = "column";
  wrapper.style.gap = "8px";
  wrapper.style.width = "100%";
  wrapper.style.visibility = "visible";
  wrapper.style.opacity = "1";

  const heading = document.createElement("p");
  heading.className = "ai-chatbot__faq-heading";
  heading.textContent = "Browse FAQs by category";
  wrapper.appendChild(heading);

  FAQ_CATEGORIES.forEach(function (categoryLabel) {
    const button = document.createElement("button");

    button.type = "button";
    button.className = "ai-chatbot__faq-category";
    button.textContent = categoryLabel;

    // Force every category button to remain visible.
    button.style.display = "block";
    button.style.visibility = "visible";
    button.style.opacity = "1";
    button.style.width = "100%";
    button.style.minHeight = "40px";
    button.style.flexShrink = "0";

    button.addEventListener("click", function () {
      showFAQQuestions(categoryLabel);
    });

    wrapper.appendChild(button);
  });

  messages.appendChild(wrapper);
  messages.scrollTop = messages.scrollHeight;
}

function showFAQQuestions(categoryLabel) {
  clearFAQMenus();

  const faqs = window.DASH_TWINE_FAQS || [];

  const matchingFAQs = faqs.filter(function (faq) {
    return getFAQCategory(faq) === categoryLabel;
  });

  const wrapper = document.createElement("div");
  wrapper.className = "ai-chatbot__faq-questions";

  const heading = document.createElement("p");
  heading.className = "ai-chatbot__faq-heading";
  heading.textContent = categoryLabel + " — choose a question:";
  wrapper.appendChild(heading);

  if (matchingFAQs.length === 0) {
    const emptyMessage = document.createElement("p");
    emptyMessage.textContent =
      "No questions are available in this category yet.";
    wrapper.appendChild(emptyMessage);
  } else {
    matchingFAQs.forEach(function (faq) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "ai-chatbot__faq-question";
      button.textContent = faq.question;

      
button.addEventListener("click", function () {
  // Keep the selected category open.
  // Remove only the question list, not the category heading permanently.
  const oldAnswer = messages.querySelectorAll(
    ".ai-chatbot__message--user, .ai-chatbot__message-link, .ai-chatbot__products"
  );

  oldAnswer.forEach(function (element) {
    element.remove();
  });

  messages.querySelectorAll(
    ".ai-chatbot__message--bot"
  ).forEach(function (element) {
    element.remove();
  });

  answerFAQ(faq, faq.question);

  messages.scrollTop = messages.scrollHeight;
});


      wrapper.appendChild(button);
    });
  }

  const backButton = document.createElement("button");
  backButton.type = "button";
  backButton.className = "ai-chatbot__faq-back";
  backButton.textContent = "← All FAQ categories";

  backButton.addEventListener("click", showFAQCategories);
  wrapper.appendChild(backButton);

  messages.appendChild(wrapper);
  messages.scrollTop = messages.scrollHeight;
}

function answerFAQ(faq, userQuestion) {
  if (!faq || !faq.answer) {
    addMessage(
      "Our team will need to confirm the current policy for this request. Please contact Dash & Twine support for accurate assistance.",
      "bot"
    );

    addContactActions(userQuestion);
    return;
  }

  addMessage(faq.answer, "bot");

  if (faq.link && faq.link.url && faq.link.text) {
    try {
      const linkURL = new URL(
        faq.link.url,
        window.location.origin
      );

      if (linkURL.protocol === "https:") {
        addLink({
          text: faq.link.text,
          url: linkURL.href
        });
      }
    } catch (error) {
      console.warn("Invalid FAQ link:", error);
    }
  }

  if (faq.contact === true) {
    addContactActions(userQuestion);
  }
}



    /* =====================================================
       BACKEND CHAT REQUEST
    ===================================================== */

    async function sendMessageToBackend(message) {
      try {
        const response = await fetch(CHATBOT_API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            sessionId: sessionId,
            message: message
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.message || "Chat request failed: " + response.status
          );
        }

        return data;
      } catch (error) {
        console.error("Chatbot API Error:", error);

        return {
          success: false,
          message:
            "Sorry, I'm having trouble connecting right now. Please contact our support team."
        };
      }
    }

    /* =====================================================
       SEND MESSAGE
    ===================================================== */
    
async function sendMessage(text) {
  const clean = String(text || "").trim();

  if (!clean || input.disabled) return;

  addMessage(clean, "user");
  input.value = "";
  input.disabled = true;

  try {
    const faq = findMatchingFAQ(clean);

    if (faq) {
      answerFAQ(faq, clean);
      return;
    }

    addMessage(
      "Please select an FAQ category below or contact our team directly.",
      "bot"
    );

    addContactActions(clean);
  } catch (error) {
    console.error("FAQ Error:", error);

    addMessage(
      "Please contact our team for assistance.",
      "bot"
    );

    addContactActions(clean);
  } finally {
    input.disabled = false;
  }
}
 

    /* =====================================================
       FORM SUBMIT
    ===================================================== */

    if (form && input) {
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    sendMessage(input.value);
  });
}

    /* =====================================================
       QUICK QUESTIONS
    ===================================================== */

    // quickButtons.forEach(function (button) {
    //   button.addEventListener("click", function () {
    //     const question = button.getAttribute("data-question");

    //     if (question) {
    //       sendMessage(question);
    //     }
    //   });
    // });

    /* =====================================================
       INITIAL MESSAGE
    ===================================================== */

    /* =========================================================
   INITIAL MESSAGE + FAQ CATEGORIES
   ========================================================= */


if (messages.children.length === 0) {
  addMessage(
    "Hello! 👋 Welcome to Dash & Twine Support. Select an FAQ category below to find answers, or contact our team directly using WhatsApp, Call Us or Email Us.",
    "bot"
  );
}

// Show categories even if a welcome message already exists.
if (!messages.querySelector(".ai-chatbot__faq-menu")) {
  showFAQCategories();
}

if (!messages.querySelector(".ai-chatbot__contact-actions")) {
  addContactActions("General enquiry");
}

  }

  /* =====================================================
     INIT
  ===================================================== */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAIChatbot);
  } else {
    initAIChatbot();
  }
})();
